import { LicenseInfo } from '@material-ui/x-grid';

LicenseInfo.setLicenseKey(
  '586f8549dd34d610c4e1514f46695c6eT1JERVI6MjUwNTQsRVhQSVJZPTE2NTMwNzA0NDkwMDAsS0VZVkVSU0lPTj0x',
);
